import React, {useContext} from 'react';
import {IconButton as PathIconButton} from '@ellucian/react-design-system/core';
import {IconButton} from '@mui/material';
import {PathDesignContext} from 'src/components/path-design-context';
import Icon from 'shared/components/icon';
import FileDownloadIcon from 'shared/img/file-download.svg';
import {connect} from 'react-redux';
import Tooltip from 'src/components/tooltip';
import {CollegePortalStore} from 'src/types/store';
import {StudentFilters} from '../../../views/college-portal/filters/types';
import $ from 'jquery';
import {EducationPhase} from '../../../types/enums';
import styles from './styles.module.scss';

export interface BulkStudentActions {
  actionsActive: boolean;
  canMessage: boolean;
  searchInput?: React.ReactNode;
  sendMessageToSelected?: () => void;
  downloadUrl?: string;
  studentFiltersForSelected?: Partial<StudentFilters>;
  educationPhase: EducationPhase;
}

const disabledText = {
  download: 'Make a table selection to download data',
  message: 'Make a table selection to message followers',
  view: 'Make a table selection to view students',
};

const DataCardActions = (props: BulkStudentActions) => {
  const path = useContext(PathDesignContext);
  const Button = path.enabled ? PathIconButton : IconButton;
  const studentFiltersForSelected = {
    ...(props.studentFiltersForSelected || {}),
    currentStudents: 1,
    educationPhase: props.educationPhase,
  };
  return (
    <div className={styles.container}>
      {props.searchInput}
      {props.downloadUrl && (
        <Tooltip title={props.actionsActive ? null : disabledText.download}>
          <div>
            <Button
              href={props.downloadUrl || ''}
              target="_blank"
              disabled={!props.actionsActive}
              size="small"
              aria-label="Download data"
              className={path.enabled ? styles.pathIcon : styles.icon}
              disableRipple
            >
              <FileDownloadIcon width={14} height={18} />
            </Button>
          </div>
        </Tooltip>
      )}
      {props.studentFiltersForSelected && (
        <Tooltip title={props.actionsActive ? null : disabledText.view}>
          <div>
            <Button
              href={`/college-portal/search?${$.param(studentFiltersForSelected)}`}
              target="_blank"
              disabled={!props.actionsActive}
              size="small"
              aria-label="View students"
              className={path.enabled ? styles.pathIcon : styles.icon}
              disableRipple
            >
              <Icon iconType="eye" />
            </Button>
          </div>
        </Tooltip>
      )}
      {props.canMessage && props.sendMessageToSelected && (
        <Tooltip title={props.actionsActive ? null : disabledText.message}>
          <div>
            <Button
              onClick={props.sendMessageToSelected}
              disabled={!props.actionsActive}
              size="small"
              aria-label="Send bulk message to students"
              className={path.enabled ? styles.pathIcon : styles.icon}
              disableRipple
            >
              <Icon iconType="envelope" />
            </Button>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default connect((state: CollegePortalStore) => ({canMessage: state.user.canMessage}))(
  DataCardActions
);
